import React, { Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import HistoryDisplayContainer from 'src/ui/library/HistoryDisplay';
import AssignmentsDetailTabPres from '../AssignmentsDetail/AssignmentsDetailTabPres';
import AssignmentsInfoContainer from '../../containers/AssignmentsDetail/AssignmentsInfoContainer';
import Spinner from 'src/ui/library/Spinner/Spinner';
import { ASSIGNMENT_RELATED_ENTITIES } from 'src/constants/constants.js';
import RelatedEntitiesLanding from 'src/ui/library/RelatedEntities';
import { formatDate } from 'src/helpers/date';

export default function AssignmentsDetailPres(props) {
  const {
    tab,
    header,
    isLoading,
    getPropsForRelatedEntities,
    getTableColumnsForRelatedEntities,
    decodeCurrencyData,
    encodeCurrencyData,
  } = props;

  const assignmentId = props.match.params.assignmentId;

  let formattedDate = '—';

  if (header.endDate) formattedDate = formatDate(header.endDate);

  if (isLoading) {
    return (
      <div style={{ marginTop: '10%' }}>
        <Spinner size={70} />
      </div>
    );
  }

  return (
    <Fragment>
      <div className="assignments-detail-header">
        <Grid container className="header-grid" spacing={0}>
          <Grid item xs={1}>
            <HistoryDisplayContainer history={props.history} type={'white'} />
          </Grid>
          <Grid item>
            <div className="header-field">
              <label className="field-label">Employee name</label>
              <span className="field-text">{header.employeeName}</span>
            </div>
          </Grid>
          <Grid item>
            <div className="header-field">
              <label className="field-label">Host country</label>
              <span className="field-text">{header.hostCountry}</span>
            </div>
          </Grid>
          <Grid item>
            <div className="header-field">
              <label className="field-label">Home country</label>
              <span className="field-text">{header.homeCountry}</span>
            </div>
          </Grid>
          <Grid item>
            <div className="header-field">
              <label className="field-label">Policy</label>
              <span className="field-text">{header.policy}</span>
            </div>
          </Grid>
          <Grid item>
            <div className="header-field">
              <label className="field-label">Open/Closed</label>
              <span className="field-text">{header.openClosed}</span>
            </div>
          </Grid>
          <Grid item>
            <div className="header-field">
              <label className="field-label">End date</label>
              <span className="field-text">{formattedDate}</span>
            </div>
          </Grid>
        </Grid>
      </div>
      <Grid container className="assignments-detail-content" spacing={0}>
        <Grid item xs={12} className="assignments-detail-tabs">
          <AssignmentsDetailTabPres tab={tab} onChange={props.handleTabSelect} />
        </Grid>
        <Grid item xs={12} className="assignments-detail-body">
          {tab === 0 && <AssignmentsInfoContainer {...props} />}
          {tab === 1 && (
            <RelatedEntitiesLanding
              topLevelRecordId={assignmentId}
              recordId={assignmentId}
              entity={ASSIGNMENT_RELATED_ENTITIES.serviceInitServices}
              getTableColumns={getTableColumnsForRelatedEntities}
              getProps={getPropsForRelatedEntities}
              decodeCurrencyData={decodeCurrencyData}
              encodeCurrencyData={encodeCurrencyData}
            />
          )}
        </Grid>
      </Grid>
    </Fragment>
  );
}
